webpackJsonp([163091915015603],{

/***/ 2053:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TreatmentEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"Treatment","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-treatment-edge-435a6e189dc1eaec4d8f.js